import {
    ContactFormColorRules,
    FilledItemColorRules, OutlinedItemColorRules,
    ProcessStepColorRules,
    SimpleItemColorRules
} from "@/scripts/common/templateDefaults/colorRules.js";

const DEFAULT_CARD_COLOR_INDEX = 3;

export function getNavigationColorMap(rules = SimpleItemColorRules) {
    return {
        colorIndex: 1,
        clusterName: 'navigation',
        colorTypes: {
            fill: {
                displayValue: rules.fill?.idle.default === 'selected',
                colorRule: rules.fill ? rules.fill : null,
            },
            outline: {
                colorRule: rules.outline ? rules.outline : null,
            },
            text: {
                displayValue: rules.text?.idle.default === 'selected',
                colorRule: rules.text ? rules.text : null
            },
        },

        // TODO delete
        clusterItems: {
            navigationFill: {
                displayValue: rules.fill?.default === 'selected',
                colorRule: rules.fill
            },
            navigationOutline: {
                colorRule: rules.outline
            },
            navigation: {
                displayValue: rules.text?.default === 'selected',
                colorRule: rules.text
            },
            navigationFillHover: {
                colorRule: rules.fillHover
            },
            navigationOutlineHover: {
                colorRule: rules.outlineHover
            },
            navigationHover: {
                colorRule: rules.textHover
            }
        },
        // TODO check if userRules is needed at all
        useRules: rules
    }
}
export function getButtonColorMap(rules = FilledItemColorRules) {
    return {
        colorIndex: 2,
        clusterName: 'button',
        colorTypes: {
            fill: {
                displayValue: rules.fill?.idle.default === 'selected',
                colorRule: rules.fill ? rules.fill : null,
            },
            outline: {
                colorRule: rules.outline ? rules.outline : null,
            },
            text: {
                displayValue: rules.text?.idle.default === 'selected',
                colorRule: rules.text ? rules.text : null,
            },
        },

        // TODO delete
        clusterItems: {
            buttonFill: {
                displayValue: rules.fill?.default === 'selected',
                colorRule: rules.fill
            },
            buttonOutline: {
                colorRule: rules.outline
            },
            buttonText: {
                displayValue: rules.text?.default === 'selected',
                colorRule: rules.text,
            },
            buttonFillHover: {
                colorRule: rules.fillHover
            },
            buttonOutlineHover: {
                colorRule: rules.outlineHover
            },
            buttonTextHover: {
                colorRule: rules.textHover
            }
        },
        useRules: rules
    }
}
export function getSecondaryButtonColorMap(rules = FilledItemColorRules) {
    return {
        colorIndex: 0,
        clusterName: 'secondaryButton',
        colorTypes: {
            fill: {
                displayValue: rules.fill?.idle.default === 'selected',
                colorRule: rules.fill ? rules.fill : null,
            },
            outline: {
                colorRule: rules.outline ? rules.outline : null,
            },
            text: {
                displayValue: rules.text?.idle.default === 'selected',
                colorRule: rules.text ? rules.text : null,
            },
        },

        // TODO delete
        clusterItems: {
            secondaryButtonFill: {
                displayValue: rules.fill?.default === 'selected',
                colorRule: rules.fill
            },
            secondaryButtonOutline: {
                colorRule: rules.outline
            },
            secondaryButtonText: {
                displayValue: rules.text?.default === 'selected',
                colorRule: rules.text,
            },
            secondaryButtonFillHover: {
                colorRule: rules.fillHover
            },
            secondaryButtonOutlineHover: {
                colorRule: rules.outlineHover
            },
            secondaryButtonTextHover: {
                colorRule: rules.textHover
            }
        },
        useRules: rules
    }
}
export function getLabelColorMap(rules = FilledItemColorRules) {
    return {
        colorIndex: 0,
        clusterName: 'label',
        colorTypes: {
            fill: {
                displayValue: rules.fill?.idle.default === 'selected',
                colorRule: rules.fill ? rules.fill : null,
            },
            outline: {
                colorRule: rules.outline ? rules.outline : null,
            },
            text: {
                displayValue: rules.text?.idle.default === 'selected',
                colorRule: rules.text ? rules.text : null,
            },
        },

        clusterItems: {
            labelFill: {
                displayValue: rules.fill?.default === 'selected',
                colorRule: rules.fill
            },
            labelOutline: {
                colorRule: rules.outline
            },
            labelText: {
                displayValue: rules.text?.default === 'selected',
                colorRule: rules.text,
            }
        },
        useRules: rules
    }
}
export function getContactFormColorMap(rules = ContactFormColorRules) {
    return {
        colorIndex: 3,
        clusterName: 'contactForm',
        colorTypes: {
            outline: {
                displayValue: true,
                colorRule: rules.outline
            },
            text: {
                colorRule: rules.text
            },
        },

        // TODO delete
        clusterItems: {
            contactFormOutline: {
                displayValue: true,
                colorRule: rules.outline
            },
            contactFormText: {
                colorRule: rules.text
            }
        },
        useRules: rules
    }
}
export function getProcessStepColorMap(rules = ProcessStepColorRules) {
    return {
        colorIndex: 0,
        clusterName: 'processStep',
        colorTypes: {
            fill: {
                displayValue: rules.fill?.active.default === 'selected',
                colorRule: rules.fill
            },
            outline: {
                colorRule: rules.outline
            },
            text: {
                colorRule: rules.text ? rules.text : null,
            },
        },

        // TODO delete
        clusterItems: {
            processOutline: {
                colorRule: rules.outline
            },
            processText: {
                colorRule: rules.text
            },
            processFillActive: {
                displayValue: rules.fillActive?.default === 'selected',
                colorRule: rules.fillActive,
            },
            processTextActive: {
                colorRule: rules.textActive
            }
        },
        useRules: rules
    }
}
export function getSocialIconColorMap(rules = FilledItemColorRules) {
    return {
        colorIndex: 2,
        clusterName: 'socialIcon',
        colorTypes: {
            fill: {
                displayValue: rules.fill?.idle.default === 'selected',
                colorRule: rules.fill ? rules.fill : null,
            },
            outline: {
                colorRule: rules.outline ? rules.outline : null,
            },
            text: {
                displayValue: rules.text?.idle.default === 'selected',
                colorRule: rules.text ? rules.text : null,
            },
        },

        // TODO delete
        clusterItems: {
            socialIconText: {
                displayValue: rules.text?.idle.default === 'selected',
                colorRule: rules.text
            },
            socialIconFill: {
                displayValue: rules.fill?.idle.default === 'selected',
                colorRule: rules.fill
            },
            socialIconOutline: {
                colorRule: rules.outline
            },
            socialIconTextHover: {
                colorRule: rules.textHover
            },
            socialIconFillHover: {
                colorRule: rules.fillHover
            },
            socialIconOutlineHover: {
                colorRule: rules.outlineHover
            }
        },
        useRules: rules,
    }
}

export function getCardColorMap(rules = FilledItemColorRules, colorIndex = DEFAULT_CARD_COLOR_INDEX) {
    return {
        colorIndex,
        clusterName: 'card',
        colorTypes: {
            fill: {
                displayValue: rules.fill?.idle.default === 'selected',
                colorRule: rules.fill ? rules.fill : null,
            },
            outline: {
                colorRule: rules.outline ? rules.outline : null,
            },
        },
        clusterItems: {
            cardFill: {
                displayValue: rules.fill?.idle.default === 'selected',
                colorRule: rules.fill
            },
            cardOutline: {
                colorRule: rules.outline
            },
        },
        useRules: rules
    }
}

export const defaultColorMap = {
    HEADING: {
        colorIndex: 0,
        clusterItems: ['heroTitle', 'heroSubtitle', 'projectTitle', 'h1', 'h2', 'h3', 'h4'],
        colorTypeToSet: 'text'
    },
    PARAGRAPH: {
        colorIndex: 1,
        clusterItems: ['heroParagraph', 'projectSubtitle', 'p1', 'p2'],
        colorTypeToSet: 'text'
    },
    HYPERLINK: {
        colorIndex: 0,
        clusterItems: ['hyperLink'],
        colorTypeToSet: 'text'
    },
    DIVIDER_LINE: {
        colorIndex: 3,
        clusterItems: ['dividerLine'],
        colorTypeToSet: 'fill'
    },
    BACKGROUND: {
        colorIndex: 4,
        clusterItems: ['background'],
        colorTypeToSet: 'fill'
    },
    FOREGROUND: {
        colorIndex: 3,
        clusterItems: ['sidebarBackground'],
        colorTypeToSet: 'fill'
    },
    CARD: getCardColorMap(),
    NAVIGATION: getNavigationColorMap(),
    BUTTON: getButtonColorMap(),
    SECONDARY_BUTTON: getSecondaryButtonColorMap(),
    LABEL: getLabelColorMap(),
    CONTACT_FORM: getContactFormColorMap(),
    PROCESS: getProcessStepColorMap(),
    SOCIAL_ICON: getSocialIconColorMap()
}

export function getColorPaletteWithUpdatedColorMap(colorPalette, params = {}) {
    const {
        navItemType = 'simple',
        buttonType = 'filled',
        secondaryButtonType = 'outlined',
        socialLinkType = 'simple',
        cardType = 'fill',
        labelType = 'solid',
    } = params;

    // Normalize 'underline' to 'outlined'
    const normalizedButtonType = buttonType === 'underline' ? 'outlined' : buttonType;
    const normalizedSecondaryButtonType = secondaryButtonType === 'underline' ? 'outlined' : secondaryButtonType;

    const navItemColorRules = navItemType === 'simple'
        ? SimpleItemColorRules
        : navItemType === 'filled'
            ? FilledItemColorRules
            : OutlinedItemColorRules;

    const buttonColorRules = normalizedButtonType === 'filled'
        ? FilledItemColorRules
        : OutlinedItemColorRules;

    const secondaryButtonColorRules = normalizedSecondaryButtonType === 'filled'
            ? FilledItemColorRules
            : OutlinedItemColorRules;

    const labelColorRules = labelType === 'outlined'
        ? OutlinedItemColorRules
        : FilledItemColorRules;

    const socialIconColorRules = socialLinkType === 'simple'
        ? SimpleItemColorRules
        : socialLinkType === 'filled'
            ? FilledItemColorRules
            : OutlinedItemColorRules;

    const cardColorRules = cardType === 'fill'
        ? FilledItemColorRules
        : OutlinedItemColorRules;

    const baseCardColorIndex = colorPalette.COLOR_MAP?.CARD?.colorIndex ?? DEFAULT_CARD_COLOR_INDEX;
    return {
        ...colorPalette,
        COLOR_MAP: {
            ...colorPalette.COLOR_MAP ? colorPalette.COLOR_MAP : defaultColorMap,
            NAVIGATION: getNavigationColorMap(navItemColorRules),
            BUTTON: getButtonColorMap(buttonColorRules),
            SECONDARY_BUTTON: getSecondaryButtonColorMap(secondaryButtonColorRules),
            LABEL: getLabelColorMap(labelColorRules),
            SOCIAL_ICON: getSocialIconColorMap(socialIconColorRules),
            CARD: getCardColorMap(cardColorRules, baseCardColorIndex),
        }
    }
}
